import httpContext from '@rover/rsdk/src/modules/Network/httpContext';

export default function getFullUrl(): string {
  if (process.env.JS_ENV_SERVER) {
    const req = httpContext.getReq();

    if (!req) throw new Error('Could not determine full URL, request object is missing');

    const { protocol } = req;
    const host = req.get('host');
    const { originalUrl } = req;
    return `${protocol}://${host}${originalUrl}`;
  }

  if (process.env.JS_ENV_CLIENT) {
    return window.location.href;
  }

  // Should be unreachable - are we not in an SSR or browser environment?
  throw new Error('Could not determine full URL');
}

export function getURL(): URL {
  return new URL(getFullUrl());
}

export function getPath(): string {
  return getURL().pathname;
}

export function getOrigin(): string {
  return getURL().origin;
}

export const getAbsoluteUrl = (urlOrPathname: string): URL =>
  new URL(urlOrPathname, getURL().origin);
